import {
	AUTH_LOGIN_REQUEST,
	AUTH_LOGIN_FAILURE,
	AUTH_LOGIN_SUCCESS,
	AUTH_LOGOUT,
} from '../constants/actionTypes';

const initialState = {
	isAuthenticating: false,
	isAuthenticated: false,
	message: {
		type: '',
		text: '',
	},
	token: null,
	user: false,
	can: false,
	timezoneOffset: false,
};

export default function auth(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case AUTH_LOGIN_REQUEST:
			return {
				...state,
				isAuthenticating: true,
				message: {
					type: '',
					text: '',
				},
				token: false,
				user: false,
				can: false,
				timezoneOffset: false,
			};

		case AUTH_LOGIN_FAILURE:
			return {
				...state,
				isAuthenticating: false,
				isAuthenticated: false,
				message: {
					type: 'error',
					text: payload.text,
				},
				token: null,
				user: false,
				can: false,
				timezoneOffset: false,
			};

		case AUTH_LOGIN_SUCCESS:
			return {
				...state,
				isAuthenticating: false,
				isAuthenticated: true,
				message: {
					type: 'success',
					text: payload.text,
				},
				token: payload.token,
				user: payload.user.id,
				can: payload.user.can,
				groups: payload.user.groups,
				timezoneOffset: payload.user.timezone_offset,
				eComToken: payload.eComToken,
			};

		case AUTH_LOGOUT:
			return {
				...initialState,
				isAuthenticating: false,
				isAuthenticated: false,
				message: {
					type: 'success',
					text: payload.text,
				},
				token: null,
				user: false,
				can: false,
				timezoneOffset: false,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js